export default __webpack_public_path__ + "static/media/job_offer19_l.86b149fb.jpg";